import { createContext, useContext, useState, useCallback } from 'react';
import type { FC, ReactNode } from 'react';

interface ProfilePictureContextValue {
  /** Incremented every time the current user uploads a new picture. */
  avatarVersion: number;
  /** Call this after a successful profile-picture upload. */
  bumpAvatarVersion: () => void;
}

const ProfilePictureContext = createContext<ProfilePictureContextValue | undefined>(undefined);

export const ProfilePictureProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [avatarVersion, setAvatarVersion] = useState(0);
  const bumpAvatarVersion = useCallback(() => setAvatarVersion((v) => v + 1), []);

  return (
    <ProfilePictureContext.Provider value={{ avatarVersion, bumpAvatarVersion }}>
      {children}
    </ProfilePictureContext.Provider>
  );
};

export const useProfilePicture = (): ProfilePictureContextValue => {
  const ctx = useContext(ProfilePictureContext);
  if (!ctx) throw new Error('useProfilePicture must be used within ProfilePictureProvider');
  return ctx;
};
